import React from "react";
import PropTypes from "prop-types";
import RadioButtonGroup from "../common/RadioButtonGroup";
import Row from "../common/Row";

const MinimaleEisenVraag = (props) => {

    const { label, value, tooltip, fieldname, items, errors, onChange, disabled, validationMessageType } = props;
    return (<Row>
        <RadioButtonGroup label={label}
            disabled={disabled}
            name={fieldname}
            value={value}
            size={6}
            items={items}
            onChange={onChange}
            horizontal
            tooltip={tooltip}
            tooltipWindowWidth={25}
            validationMessage={errors ? errors[fieldname] : ''}
            validationMessageType={validationMessageType} />
    </Row>);
};

MinimaleEisenVraag.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.oneOf([PropTypes.bool, PropTypes.number]),
    tooltip: PropTypes.string,
    fieldname: PropTypes.string,
    errors: PropTypes.object,
    onChange: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.any })),
    validationMessageType: PropTypes.string
};

export default MinimaleEisenVraag;